// @core/api/endpoints/localization/delete_translation_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/localization';

/**
 * Delete translation key
 * Deletes a translation key and all its translations across all locales.
 */
export async function DeleteTranslationKey(
  key_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/keys/:key_id`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
